import isNull from 'lodash/isNull';
import { useEffect, useMemo, useState } from 'react';
import type { SingleValue } from 'react-select';

import { Select } from '@revelio/ui';

import styles from './ToggleSelect.module.css';

export type ToggleSelectOption = {
  index: number;
  value: string;
  label: string;
};

interface ToggleSelectProps {
  filterName: string;
  onChange?: (e: number) => void;
  initialIsCurrent: boolean;
}

export const ToggleSelect = ({
  filterName = '',
  onChange,
  initialIsCurrent,
}: ToggleSelectProps) => {
  const options: [ToggleSelectOption, ToggleSelectOption] = useMemo(
    () => [
      {
        index: 0,
        value: `Current ${filterName}`,
        label: `Current ${filterName}`,
      },
      {
        index: 1,
        value: `Previous ${filterName}`,
        label: `Previous ${filterName}`,
      },
    ],
    [filterName]
  );

  useEffect(() => {
    setSelectedOption(initialIsCurrent ? options[0] : options[1]);
  }, [initialIsCurrent, options]);

  const [selectedOption, setSelectedOption] = useState<{
    label: string;
    value: string;
  } | null>(initialIsCurrent ? options[0] : options[1]);

  const availableOptions = selectedOption?.value.includes('Current')
    ? [options[1]]
    : [options[0]];

  return (
    <div className={styles.wrapper}>
      <Select<ToggleSelectOption>
        className={styles.select}
        classNamePrefix="toggle-select"
        size="sm"
        variant="filled"
        value={
          selectedOption?.value.includes('Current') ? options[0] : options[1]
        }
        options={availableOptions}
        onChange={(e: SingleValue<ToggleSelectOption>) => {
          if (isNull(e)) return;
          setSelectedOption(e);
          onChange?.(e.index);
        }}
        blurInputOnSelect={false}
        isSearchable={false}
        menuPortalTarget={null}
      />
    </div>
  );
};
